module.exports = __webpack_public_path__ + "static/media/back-silver.c63fc343.png";